// extracted by mini-css-extract-plugin
export default {"cardsSectionWrapper":"styles_cardsSectionWrapper__odjVO","separator":"styles_separator__rqH1z","separatorText":"styles_separatorText__g7wky"};